import { TDraftRoutes } from './types';

const paths = {
  home() {
    return '/';
  },
  addNewTour() {
    return '/tour/add-new';
  },
  listYourTour() {
    return '/list-your-tour';
  },
  draft(draftId: string, pathname: TDraftRoutes) {
    return `/draft/${draftId}/${pathname}`;
  },
  terms() {
    return '/terms-and-conditions';
  },
  privacy() {
    return '/privacy-policy';
  },
  categoryShow(slug: string) {
    return `/category/${slug}`;
  },
  tourAvailability(tourId: string, queryString: string) {
    return `/tours/${tourId}?${queryString.toString()}`;
  },
  tourShow(tourId: number) {
    return `/tours/${tourId}`;
  },
  reservationShow(tourId: number, resId: string) {
    return `/tours/${tourId}?resId=${resId}`;
  },
  profile() {
    return '/profile';
  },
  register() {
    return '/register';
  },
  registerTourOperater() {
    return '/register-tour-operater';
  },
  photographers() {
    return '/photographers';
  },
  /** Browse tours (search) — SEO-friendly query: `country`, `experience`, filters */
  search(params?: { tourOperatorId?: string }) {
    if (params?.tourOperatorId) {
      return `/tours?tourOperatorId=${encodeURIComponent(params.tourOperatorId)}`;
    }
    return '/tours';
  },
  /** Country destination landing page (slug from API, e.g. kenya, south-africa). Caller must pass a slug. */
  destinationCountry(slug: string) {
    const s = (slug || '').trim().replace(/^\/+|\/+$/g, '');
    return `/destinations/${encodeURIComponent(s)}`;
  },
  /** Experience landing page (slug from ContentDto in GET …/content). Caller must pass a slug. */
  experience(slug: string) {
    const s = (slug || '').trim().replace(/^\/+|\/+$/g, '');
    return `/experiences/${encodeURIComponent(s)}`;
  },
  blog() {
    return '/blog';
  },
  blogPost(slug: string) {
    const s = (slug || '').trim().replace(/^\/+|\/+$/g, '');
    return `/blog/${encodeURIComponent(s)}`;
  },
  blogListing(page = 1) {
    return page > 1 ? `/blog/page/${page}` : '/blog';
  },
  blogTopic(slug: string) {
    const s = (slug || '').trim().replace(/^\/+|\/+$/g, '');
    return `/blog/topics/${encodeURIComponent(s)}`;
  },
  /** Editorial guide page (static App Router pages under /guides). Caller must pass a slug. */
  guide(slug: string) {
    const s = (slug || '').trim().replace(/^\/+|\/+$/g, '');
    return `/guides/${encodeURIComponent(s)}`;
  },
  /** Footer / deep link — slug must match backend `ContentDto.slug` (e.g. gorilla-trekking). */
  searchGorillaTrekking() {
    return this.experience('gorilla-trekking');
  },
  tours() {
    return '/tours';
  },
  /** Build `/tours?country=…&experience=…` (and other filter params) from `TFilters`. */
  toursQuery(filters: Partial<import('./types').TFilters>) {
    const params = new URLSearchParams();
    const append = (key: string, value: unknown) => {
      if (value === undefined || value === null || value === '') return;
      if (typeof value === 'number' && Number.isNaN(value)) return;
      if (typeof value === 'boolean') {
        if (value) params.set(key, 'true');
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((v) => {
          if (v !== undefined && v !== null) params.append(key, String(v));
        });
        return;
      }
      params.set(key, String(value));
    };

    const { country, experience, ...rest } = filters;
    append('country', country);
    append('experience', experience);
    for (const [key, value] of Object.entries(rest)) {
      append(key, value);
    }
    const q = params.toString();
    return q ? `/tours?${q}` : '/tours';
  },
  /** @deprecated Use `toursQuery` */
  searchActivity(filters: import('./types').TFilters) {
    return this.toursQuery(filters);
  },
  operatorProfile(id: number | string, slug: string) {
    return `/operators/${slug}-${id}`;
  },
  account: {
    bookings() {
      return '/account/bookings';
    },
    myTours() {
      return '/account/my-tours';
    },
    myAgency() {
      return '/account/my-agency';
    },
    reservations() {
      return '/account/reservations';
    },
  },
  reservation: {
    contact(tourId: string, searchParams: string) {
      return `/tours/${tourId}/reservation/contact?${searchParams}`;
    },
    paymentDetails(tourId: string, searchParams: string) {
      return `/tours/${tourId}/reservation/payment-details?${searchParams}`;
    },
    confirmation(tourId: string, searchParams: string) {
      return `/tours/${tourId}/reservation/confirmation?${searchParams}`;
    },
  },
};

export default paths;
